import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedUploadURLForQuestionOptionsRPC } from "./getPresignedUploadUrlForQuestionOptionsRPC";

export class GetPresignedUploadURLForQuestionOptionsRPCClientImpl extends GetPresignedUploadURLForQuestionOptionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedUploadURLForQuestionOptionsRPC.Request): Promise<LeoRPCResult<GetPresignedUploadURLForQuestionOptionsRPC.Response, GetPresignedUploadURLForQuestionOptionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetPresignedUploadURLForQuestionOptions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedUploadURLForQuestionOptionsRPC.ResponseDTO,
      GetPresignedUploadURLForQuestionOptionsRPC.Errors.ErrorsDTO,
      GetPresignedUploadURLForQuestionOptionsRPC.Response,
      GetPresignedUploadURLForQuestionOptionsRPC.Errors.Errors
    >(
      response,
      "survey/GetPresignedUploadURLForQuestionOptions",
      GetPresignedUploadURLForQuestionOptionsRPC.Response.fromDTO,
      GetPresignedUploadURLForQuestionOptionsRPC.Errors.fromDTO
    );
  }
}
